import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  heading: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
      marginBottom: theme.spacing(1.5),
    },
  },
  rail: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      paddingBottom: theme.spacing(1),
      marginRight: theme.spacing(-2),
      paddingRight: theme.spacing(2),
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  chip: {
    flexShrink: 0,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: 0,
    textTransform: 'none',
    height: '36px',
    padding: '0 16px',
    borderRadius: '999px',
    border: '1px solid #D5D7DC',
    backgroundColor: '#fff',
    color: theme.palette.text.primary,
    transition: 'background-color 120ms ease, color 120ms ease, border-color 120ms ease',
    '&:hover': {
      backgroundColor: '#F7F8FA',
      borderColor: '#B7BBC2',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 14px',
      height: '34px',
    },
  },
  chipSelected: {
    backgroundColor: '#ECF2F9',
    borderColor: theme.palette.blue.main,
    color: theme.palette.blue.main,
    '&:hover': {
      backgroundColor: '#DDE8F4',
      borderColor: theme.palette.blue.main,
      color: theme.palette.blue.main,
    },
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    padding: theme.spacing(1.25, 2),
    backgroundColor: '#F4F6FA',
    border: '1px solid #D5D7DC',
    borderRadius: '12px',
    color: theme.palette.text.primary,
    fontSize: '14px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      padding: theme.spacing(1, 1.5),
    },
  },
  bannerIcon: {
    // Navy sparkle marks the banner as an AI/curated affordance, matching the
    // styling used elsewhere across the web for "auto-awesome" suggestions.
    color: theme.palette.blue.main,
    fontSize: '20px',
    width: '20px',
    height: '20px',
    flexShrink: 0,
  },
  bannerCopy: {
    flex: 1,
    minWidth: 0,
  },
  bannerClear: {
    flexShrink: 0,
    fontSize: 'inherit',
    fontWeight: 500,
    textTransform: 'none',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    minWidth: 'auto',
    padding: theme.spacing(0.25, 0.75),
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
    },
  },
  bannerClearIcon: {
    fontSize: '16px',
    marginRight: theme.spacing(0.5),
  },
}))
